import { mergeArrays } from "./modules/utils";

const StandardBenchmarkTypePolicy = {
  StandardBenchmark: {
    fields: {
      levels: {
        merge: mergeArrays,
      },
    },
  },
};

export default StandardBenchmarkTypePolicy;
